/** @jsxImportSource minimal-view */

import { element, view, web } from 'minimal-view'
import { skin } from './skin'
import { Rect } from 'geometrik'
import { observe } from './util/observe'
import { screen } from './screen'
import { anim } from './anim'
import { Param } from '../vm/interface'
import { Rms } from './rms'
import { audio } from './audio'

export type ParamRms = typeof ParamRms.State

export const ParamRms = web(view('param-rms',
  class props {
    param!: Param
  },
  class local {
    host = element
    canvas?: HTMLCanvasElement
    c?: CanvasRenderingContext2D
    rect?: Rect
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
      draw = fn(({ c, param, rect: r }) => () => {
        if (!param.last?.ptr) return

        const rms = param.last.meta.rms as Rms
        if (!rms) return

        c.save()

        c.clearRect(0, 0, r.width, r.height)
        c.fillStyle = skin.$.colors.bg
        c.fillRect(0, 0, r.width, r.height)

        rms.update()
        rms.drawHoriz(c, 0, 0, r.width, r.height)

        c.restore()
      })

      resize = fn(({ host }) => async () => {
        const rect = host.getBoundingClientRect()
        if (!rect.width || !rect.height) return
        const r = new Rect(rect).roundSelf()
        if (!$.rect || r.width !== $.rect.width || r.height !== $.rect.height) {
          $.rect = r
        }
      })
    })
  },
  function effects({ $, fx, deps, refs }) {
    fx(() => skin.fx(({ fonts, colors }) => {
      $.css = /*css*/`
      & {
        display: flex;
        width: 100%;
        height: 100%;
      }

      canvas {
        height: 100%;
        width: 100%;
      }
      `
    }))

    fx(({ host }) =>
      observe.resize.initial(host, $.resize)
    )

    fx(({ canvas }) => {
      $.c = canvas.getContext('2d')!
    })

    fx(() => screen.fx(({ pr }) =>
      fx(({ canvas, rect, c }) => {
        canvas.width = rect.width * pr
        canvas.height = rect.height * pr
        // canvas.style.width = rect.width + 'px'
        // canvas.style.height = rect.height + 'px'
        // canvas.style.imageRendering = 'pixelated'

        c.scale(pr, pr)
      })
    ))

    // fx(() => audio.fx(({ dspl }) =>
    //   fx(({ param, rms }) => {
    //     if (!param.last?.ptr) return
    //     rms.index = param.last!.ptr!
    //     rms.floats = dspl.frontend.rms
    //   }))
    // )

    fx(() => {
      anim.$.entities = [...anim.$.entities, $.draw]
      return () => {
        anim.$.entities = anim.$.entities.filter((fn) =>
          fn !== $.draw
        )
      }
    })

    fx(() => {
      $.view = <canvas
        ref={refs.canvas}
      />
    })
  }
))
